<template>
  <div class="w-100">
    {{ invoiceType() }} emailed to billing contact
    <customer-object
      :entity-id="customerId()"
      :name="contactName()"
      :open-new="true"
      :tooltip="contactProfile()"
    />

    for
    <invoice-object
      :entity-id="invoiceId()"
      :invoice="$lodash.get(activity, 'detail.invoice')"
      :open-new="true"
    />
  </div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
